import React, { useState, useEffect } from "react";
import { Alert } from "react-bootstrap";
import "./alert-banner.css";

/**
 * AlertBanner Component
 *
 * Dismissible announcement banner for authenticated pages. Becomes sticky when user scrolls
 * down the page. Displays announcements about product releases and feature availability.
 *
 * @param {Object} props - Component props
 * @param {Function} props.closeAlert - Callback function to close/dismiss the banner
 * @returns {JSX.Element} Alert banner that becomes sticky on scroll
 */
function AlertBanner(props) {
  // Track whether user has scrolled away from top of page
  const [scroll, setScroll] = useState(false);

  /**
   * Monitor scroll position to trigger sticky styling
   * Sets sticky class when any scroll occurs (scrollY > 0)
   */
  useEffect(() => {
    window.addEventListener("scroll", () => {
      // Banner becomes sticky when user scrolls (not at top of page)
      if (window.scrollY === 0) {
        setScroll(false);
      } else {
        setScroll(true);
      }
    });
  }, []);

  return (
    <>
      <Alert
        onClose={props.closeAlert}
        dismissible
        className={
          // Apply sticky styling when scrolled down
          scroll
            ? "alertBannerSticky alertBannerComponent"
            : "alertBannerComponent"
        }
        id="alertBannerComponent"
      >
        <p className="alertBannerText">
          <button className="customButton customButtonStyle faqButton">
            <span>ANNOUNCEMENT</span>
          </button>{" "}
          {/* Even though{" "}
          <a
            href="https://www.linkedin.com/posts/paulleesc_roiquant-serverless-infrastructure-activity-7379443979760721920-cXPm/"
            target="_blank"
            rel="noopener noreferrer"
            className="alert-cta"
          >
            we've released roiquant app v4.0
          </a>
          , we're gradually releasing the remaining product features every week.
          <br />
          Currently only Capital Financing, Partners Marketplace, VC Funding
          Benchmarks, Shutdown Data, Commercial Data, Funding Sourcing, Startup
          Intelligence, Venture Intelligence and Simulation features are
          functional. */}
          Due to the latest AWS Activate policy updates for 2026,{" "}
          <b>we're temporarily not processing</b> any AWS Activate perks
          redemption/application <u>until further notice</u>.
        </p>
      </Alert>
    </>
  );
}

export default AlertBanner;
